import React, { Component } from 'react';
import { AgGridReact } from "ag-grid-react";
import { AllCommunityModule, ModuleRegistry, themeQuartz } from 'ag-grid-community';
import "ag-grid-enterprise";
import DailyReportsServices from '../../services/axiosServices/apiServices/DailyReportsServices';
import SwalServices from '../../services/swalServices/SwalServices';
import { getAuthProps } from '../../utils/AuthenticationLibrary';
import { isValidForm } from '../../utils/validation/CommonValidator';
import { CommonValidationMessages } from '../../utils/Messages';

// Register all Community features
ModuleRegistry.registerModules([AllCommunityModule]);

class ItemGroupDetailReport extends Component {
    constructor(props) {
        super(props);
        this.dailyReportsServices = new DailyReportsServices();
        this.SwalServices = new SwalServices();
        this.state = {
            isTable2Expanded: false,
            isTable3Expanded: false,

            t1RowData: [
                // { item_grp: "Electronics", store_qty: 120 },
                // { item_grp: "Hardware", store_qty: 250 },
                // { item_grp: "Software", store_qty: 75 },
                // { item_grp: "Tools", store_qty: 180 },
                // { item_grp: "Furniture", store_qty: 90 },
            ],

            t1ColDefs: [
                {
                    field: "itemGroup",
                    headerName: "Item grp",
                    filter: true,
                    floatingFilter: true,
                    flex: 1,
                },
                {
                    field: "storeQty",
                    headerName: "Store qty",
                    filter: true,
                    floatingFilter: true,
                    flex: 1,
                    valueFormatter: (params) => {
                        return params.value ? parseFloat(params.value).toFixed(2) : "";
                    }
                },

            ],

            t2ColDefs: [
                {
                    field: "itemCategory",
                    headerName: "Item category",
                    filter: true,
                    floatingFilter: true,
                    minWidth: window.innerWidth * 0.08,
                    flex: 1,
                },
                {
                    field: "drawingNo",
                    headerName: "Drawing no",
                    filter: true,
                    floatingFilter: true,
                    minWidth: window.innerWidth * 0.1,
                    flex: 1,
                },
                {
                    field: "itemName",
                    headerName: "Item name",
                    filter: true,
                    floatingFilter: true,
                    minWidth: window.innerWidth * 0.15,
                    flex: 1.5,
                },
                {
                    field: "stockRate",
                    headerName: "Stock rate",
                    filter: true,
                    floatingFilter: true,
                    minWidth: window.innerWidth * 0.1,
                    flex: 1,
                },
                {
                    field: "storeQty",
                    headerName: "Store qty",
                    filter: true,
                    floatingFilter: true,
                    minWidth: window.innerWidth * 0.1,
                    flex: 1,
                },
                {
                    field: "stockAmount",
                    headerName: "Stock amount",
                    filter: true,
                    floatingFilter: true,
                    minWidth: window.innerWidth * 0.1,
                    flex: 1,
                },
            ],
            t2RowData: [
                // {
                //     item_category: "Electronics",
                //     drawing_no: "DR1234",
                //     item_name: "Resistor",
                //     stock_rate: 5.25,
                //     store_qty: 200,
                //     stock_amount: 1050,
                // },                
            ],
            paginationPageSize: 50,
            rowHeight: 40,
            idCompany: 0,
            requestDetails: {
                fromDate: "",
                toDate: "",
            },
            validState: {
                isValid: true,
                error: {},
            },
            validationRules: {
                fromDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "from date"
                        ),
                    }
                ],
                toDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "to date"
                        ),
                    }
                ],
            }
        };
    }

    toggleExpandCollapseTable = (tableNumber) => {
        this.setState((prevState) => {
            if (tableNumber === 2) {
                return { isTable2Expanded: !prevState.isTable2Expanded };
            } else if (tableNumber === 3) {
                return { isTable3Expanded: !prevState.isTable3Expanded };
            } else {
                return {};
            }
        });
    };

    handleChange = (event, name) => {
        let value = event.target.value;
        let details = this.state.requestDetails;
        if (name === "fromDate") {
            details[name] = value
        } else {
            details[name] = value
        }
        this.setState({ requestDetails: details });
    };

    handleCellClick = (event) => {
        this.procItemStockRegisterTracking_ByItemGroup(event.data.idItemGroup, event.colDef.field);
    };

    componentDidMount = () => {
        let prop = getAuthProps()
        //debugger
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany }, () => {
                //this.procItemStockRegister_ForMinimumStockLevel();
            });
        } else {
            //window.location.href = "/Login";
        }
        window.addEventListener("resize", this.handleResize);
    }
    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
    }

    procItemStockRegister_GroupWise = () => {
        const isValidAllFields = this.isValidAllFields();
        if (isValidAllFields) {
            let request = {
                idCompany: this.state.idCompany,
                fromDate: this.state.requestDetails.fromDate,
                toDate: this.state.requestDetails.toDate
            };
            //let idCompany = this.state.idCompany;
            //debugger;
            this.dailyReportsServices.procItemStockRegister_GroupWise(request).then((response) => {
                //debugger
                if (response.statusCode == 200 && response.responseItem !== null) {
                    //debugger;
                    let data = response.responseItem.responseContent;
                    this.setState({ t1RowData: data }, () => {
                        //let data = this.state.userDetails;
                        //data.databaseName = databasename;
                        //this.setState({ rowData: data })
                        //this.goToNextStep()
                    });
                }
            });
        }
    }
    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.requestDetails,
            this.state.validationRules,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    procItemStockRegisterTracking_ByItemGroup = (idItemGroup, field) => {
        let request = {
            idItemGroup: idItemGroup, //this.state.idCompany,
            fromDate: this.state.requestDetails.fromDate,
            toDate: this.state.requestDetails.toDate
        };
        //let idCompany = this.state.idCompany;
        //debugger;
        this.dailyReportsServices.procItemStockRegisterTracking_ByItemGroup(request).then((response) => {
            //debugger
            if (response.statusCode == 200 && response.responseItem !== null) {
                //debugger;
                let data = response.responseItem.responseContent;
                this.setState({ t2RowData: data, isTable2Expanded: true }, () => {
                    //let data = this.state.userDetails;
                    //data.databaseName = databasename;
                    //this.setState({ rowData: data })
                    //this.goToNextStep()
                });
            }
        });
    }

    render() {
        return (
            <div className='item-group-detail-report'>
                <div className="data-display">
                    <div className="data-display-inner">
                        <div className='search-grp bg-white shadow-normalShadow rounded-[10px] p-[10px] w-[60%] mb-[10px]'>
                            <p className='mb-[5px] font-semibold text-blue text-[16px]'>Select date</p>
                            <div className='item-grp flex gap-[10px] items-end'>
                                <div className='input-grp w-full'>
                                    <label>From date</label>
                                    <input type='date' className={`px-[10px] py-[5px] ${this.state.validState?.error?.fromDate !== undefined ? "error" : ""}`}
                                        onChange={(event) => this.handleChange(event, "fromDate")}
                                    />
                                </div>
                                <div className='input-grp w-full'>
                                    <label>To date</label>
                                    <input type='date' className={`px-[10px] py-[5px] ${this.state.validState?.error?.toDate !== undefined ? "error" : ""}`}
                                        onChange={(event) => this.handleChange(event, "toDate")}
                                    />
                                </div>
                                <button className='prm-btn h-fit ml-[10px]'
                                    onClick={() => this.procItemStockRegister_GroupWise()}
                                >Search</button>
                            </div>
                        </div>
                        <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className="table-1 h-[46.5vh] w-full px-[1px] rounded-[5px]">
                                <div className="table-inner">
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Group wise stock register</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.t1RowData} // Pass row data
                                    rowHeight={this.state.rowHeight}
                                    columnDefs={this.state.t1ColDefs} // Pass column definitions
                                    pagination={true} // Enable pagination
                                    paginationPageSize={this.state.paginationPageSize}
                                    rowSelection={this.rowSelection}
                                    onCellClicked={this.handleCellClick}
                                />
                            </div>
                        </div>
                        <div className="table w-full mt-[10px] bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className={`table-2 w-full px-[1px] rounded-[5px] ${this.state.isTable2Expanded ? 'h-[448px]' : 'h-[0]'}`}>
                                <div className="table-inner" onClick={() => this.toggleExpandCollapseTable(2)}>
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Item tracking details</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.t2RowData} // Pass row data
                                    rowHeight={this.state.rowHeight}
                                    columnDefs={this.state.t2ColDefs} // Pass column definitions
                                    pagination={true} // Enable pagination
                                    paginationPageSize={this.state.paginationPageSize}
                                    rowSelection={this.rowSelection}
                                    onGridReady={this.state.onGridReady} // Rows per page
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default ItemGroupDetailReport;